import React, { useState, useEffect } from "react";
import { Card, Row, Col, Statistic, Button, message, Spin, Tag } from "antd";
import { HomeOutlined, TeamOutlined, DollarOutlined, WarningOutlined, DownloadOutlined } from "@ant-design/icons";
import { getStatistics, exportData } from "../services/api";
import { PageLoadingOverlay } from "../components/RoomLoadingScene";

const statisticsCache = new Map();

const StatisticsScreen = () => {
    const userId = JSON.parse(localStorage.getItem("user") || "{}").id || "anonymous";
    const cachedStats = statisticsCache.get(userId);
    const [stats, setStats] = useState(cachedStats || null);
    const [loading, setLoading] = useState(!cachedStats);

    useEffect(() => { loadStats(Boolean(cachedStats)); }, []);

    const loadStats = async (quiet = false) => {
        try {
            if (!quiet) setLoading(true);
            const res = await getStatistics();
            setStats(res);
            statisticsCache.set(userId, res);
        } catch (e) {} finally { if (!quiet) setLoading(false); }
    };

    const handleExport = async (type) => {
        try {
            const res = await exportData(type);
            const url = window.URL.createObjectURL(new Blob([res]));
            const a = document.createElement("a");
            a.href = url;
            a.download = (type === "rooms" ? "房源列表" : "合同列表") + ".csv";
            a.click();
            window.URL.revokeObjectURL(url);
            message.success("导出成功");
        } catch (e) { message.error("导出失败"); }
    };

    if (loading) return <PageLoadingOverlay caption="正在统计数据，请稍候…" />;

    return (
        <div className="statistics-screen">
            <h2>数据统计</h2>
            <Row className="statistics-grid" gutter={[12, 12]} style={{ marginBottom: 16 }}>
                <Col xs={12} sm={12} lg={6}>
                    <Card className="statistics-card"><Statistic title="房源总数" value={stats?.total_rooms || 0} prefix={<HomeOutlined />} /></Card>
                </Col>
                <Col xs={12} sm={12} lg={6}>
                    <Card className="statistics-card"><Statistic title="空置房源" value={stats?.vacant_rooms || 0} valueStyle={{ color: "#52c41a" }} prefix={<HomeOutlined />} /></Card>
                </Col>
                <Col xs={12} sm={12} lg={6}>
                    <Card className="statistics-card"><Statistic title="已租房源" value={stats?.rented_rooms || 0} valueStyle={{ color: "#ff4d4f" }} prefix={<HomeOutlined />} /></Card>
                </Col>
                <Col xs={12} sm={12} lg={6}>
                    <Card className="statistics-card"><Statistic title="已上架" value={stats?.listed_rooms || 0} valueStyle={{ color: "#1890ff" }} prefix={<HomeOutlined />} /></Card>
                </Col>
            </Row>
            <Row className="statistics-grid" gutter={[12, 12]} style={{ marginBottom: 16 }}>
                <Col xs={12} md={8}>
                    <Card className="statistics-card"><Statistic title="本月租金收入" value={stats?.monthly_rent || 0} prefix="¥" precision={2} valueStyle={{ color: "#1890ff" }} /></Card>
                </Col>
                <Col xs={12} md={8}>
                    <Card className="statistics-card"><Statistic title="空置率" value={stats?.vacancy_rate || 0} suffix="%" valueStyle={{ color: stats?.vacancy_rate > 30 ? "#ff4d4f" : "#52c41a" }} /></Card>
                </Col>
                <Col xs={24} md={8}>
                    <Card className="statistics-card"><Statistic title="即将到期合同" value={stats?.expiring_contracts || 0} prefix={<WarningOutlined />} valueStyle={{ color: "#faad14" }} /></Card>
                </Col>
            </Row>
            {stats?.expiring_contracts > 0 && (
                <Card style={{ marginBottom: 24, background: "#fff7e6", borderColor: "#ffd591" }}>
                    <WarningOutlined style={{ color: "#faad14", marginRight: 8 }} />
                    <span>有 {stats.expiring_contracts} 份合同将在30天内到期，请及时处理</span>
                </Card>
            )}
            <Card title="数据导出">
                <Button icon={<DownloadOutlined />} onClick={() => handleExport("rooms")} style={{ marginRight: 16 }}>导出房源列表</Button>
                <Button icon={<DownloadOutlined />} onClick={() => handleExport("contracts")}>导出合同列表</Button>
            </Card>
        </div>
    );
};

export default StatisticsScreen;
